<script lang="ts">
    import type InstagramStoryEntity from "@apps/instagram/entities/InstagramStoryEntity";
    import { filter, switchMap } from "rxjs/operators";

    import { ModalToken } from "@components/Modal/ModalManager";
    import Slider from "@components/Slider/Slider.svelte";
    import SliderArrows from "@components/Slider/SliderArrows.svelte";
    import SliderController from "@components/Slider/SliderController";

    import InstagramStoryCard from "./InstagramStoryCard.svelte";
    import InstagramStoryCardSkeleton from "./InstagramStoryCardSkeleton.svelte";

    export let stories: InstagramStoryEntity[];
    export let instagramStoriesModalToken: ModalToken<{ id: number }>;
    export let skeleton = false;
    const perPage = 5;
    const sliderController = new SliderController();
    let slidesCount$ = sliderController.connected$.pipe(
        filter((v) => !!v),
        switchMap(() => {
            return sliderController.selectSlidesCount();
        })
    );
    const handlePrev = (): void => {
        sliderController.prev();
    };
    const handleNext = (): void => {
        sliderController.next();
    };
</script>

<div class="gw-ig-stories-slide-list">
    <Slider
        {perPage}
        {sliderController}
        slidesCount={$slidesCount$}
        loop={false}
    >
        <svelte:fragment slot="slides">
            {#if skeleton}
                {#each { length: perPage } as _}
                    <div class="gw-ig-stories-slide-list__post-wrapper">
                        <InstagramStoryCardSkeleton />
                    </div>
                {/each}
            {:else}
                {#each stories as story}
                    <div class="gw-ig-stories-slide-list__post-wrapper">
                        <InstagramStoryCard
                            {story}
                            {instagramStoriesModalToken}
                        />
                    </div>
                {/each}
            {/if}
        </svelte:fragment>
        <svelte:fragment slot="arrows">
            {#if stories.length >= perPage}
                <SliderArrows
                    on:nextSlide={handleNext}
                    on:prevSlide={handlePrev}
                />
            {/if}
        </svelte:fragment>
    </Slider>
</div>

<style>
    .gw-ig-stories-slide-list {
        position: relative;
        width: 100%;
        margin: 0 auto 30px;
    }

    .gw-ig-stories-slide-list__post-wrapper {
        margin: 0 5px;
    }
</style>
